import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import Icon from "../../components/icons";
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useDataSourceApi } from '../../store/api/hooks/dataSourceApiHook';
import { toast } from 'react-hot-toast';
import Spinner from "../../components/iconSvgs/spinner";

interface IncomingProps {
    isAddBtnDisabled: boolean;
}

const InternalDatabase  = ({isAddBtnDisabled}: IncomingProps) => {
    const [file, setFile] = useState<File | null>(null);
    const [progress, setProgress] = useState(50);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);

    const dataSourceAPI = useDataSourceApi();
    const branchDS = useStoreBrnDSSelector();
    const navigate = useNavigate();

    const maxSize = 25 * 1024 * 1024; // 25MB in bytes // 1024; //  

    const formatFileSize = (size: number) => {
        if (size < 1024) {
            return `${size} Bytes`;
        } else if (size < 1024 * 1024) {
            return `${(size / 1024).toFixed(2)} KB`;
        } else {
            return `${(size / (1024 * 1024)).toFixed(2)} MB`;
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: { 'text/csv': ['.csv'] },
        // onDrop,
        onDrop: (acceptedFiles) => {
            const selectedFile = acceptedFiles[0];
            console.log('selectedFile =>', selectedFile);
            if (selectedFile.size > maxSize) {
                toast.error('File size exceeds the maximum limit of 25MB.');
                setFile(null); // Clear the file if size is exceeded
            }
            if (selectedFile && selectedFile.type !== 'text/csv') {
                toast.error('Please select a CSV file');
                setFile(null);
            } else {
                setFile(selectedFile);
            }
        },
    });

    const handleFileUpload = async () => {
        if (!file) return;

        setOnSubmitLoading(true);
        const formData = new FormData();
        formData.append("file", file); // Append the file to FormData

        // Optionally add other data
        formData.append("store_id", branchDS?.store_id);
        formData.append("branch_id", branchDS?.branch_id);
        console.log('formData =>', isOnSubmitLoading);
        try {
            setTimeout(() => {
                dataSourceAPI.addInternalDataSource(
                formData,
                (msg: any, resp: any) => {
                    console.log('response =>', resp);
                    if (resp?.code === 201 || resp?.code === 200) {
                        toast.success(resp?.message);
                        navigate(URLS.DATASOURCES.LIST);
                    } else {
                        toast.error(resp?.message);
                    }
                    setOnSubmitLoading(false);
                    // navigate(URLS.DATASOURCES.LIST);
                },
                (error: any, resp: any) => {
                    if (resp?.detail?.code === 400) {
                        toast.error(resp?.detail?.message);
                    }else if(resp?.detail?.code === 500){
                        toast.error(resp?.detail?.message);
                    } else {
                        toast.error("Something went wrong");
                    }
                    setOnSubmitLoading(false);
                    // navigate(URLS.DATASOURCES.LIST);
                    
                },
                // {
                //     onUploadProgress: (event: ProgressEvent) => {
                //         console.log('event =>', event);
                //         if (event.lengthComputable) {
                //             const percentCompleted = Math.round((event.loaded * 100) / event.total);
                //             setUploadProgress(percentCompleted);
                //             // setProgress(percentCompleted); 
                //         }
                //     }
                // }
            );
            setFile(null);
        }, 5000);

        } catch (error) {
            console.error('Error uploading file:', error);
            toast.error("Error uploading file");
            setOnSubmitLoading(false)
            setFile(null);
        }
    };


    const radius = 30;
    const circumference = 2 * Math.PI * radius;

    const strokeDashoffset = circumference - (uploadProgress / 100) * circumference;

    return (
        <div>
            <div className="internal-database-container bg-sky-50"
                {...getRootProps()}
            >
                {/* File Icon */}
                <div className="flex justify-center items-center mb-2 mt-[33px]">
                    <Icon name="file" size={45} className="justify-center items-center text-gray-400" />
                    <button
                        className="flex justify-start rounded-3xl bg-blue-500 p-1 -mb-[22px] -ml-[21px] text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    >
                        <Icon name="file-upload" size={16} className="m-auto" />
                    </button>
                </div>

                <p className="text-base">
                    <span className="text-blue-500">Click to Upload </span> or drop & drag
                </p>

                <input {...getInputProps()} />
            </div>
            {/* Supported Format and Maximum Size Text with Flex */}
            <div className="flex justify-between text-sm text-gray-500 mt-2">
                <p className="text-left">Supported Format: <span className="text-blue-500">.csv</span></p>
                <p className="text-right">Maximum size: 25MB</p>
            </div>
            <div>
                <a href="https://res.cloudinary.com/dl7ywbzex/raw/upload/fl_attachment/v1744958572/mixed_reviews_ilqmow.csv" className="text-blue-500 ">Download Sample CSV</a>
            </div>

            {file && (
                <div>
                    <div className="flex flex-col text-sm text-gray-500 bg-sky-50 mt-5 p-5 rounded-lg shadow-sm">
                        <div className="flex items-center mb-4">
                            <Icon name="file" size={45} className="text-gray-400 mr-4" />
                            <div className="justify-start items-center relative">
                                <h4 className="text-sm text-gray-600">{file.name}</h4>
                                <h4 className="text-sm text-gray-400">{formatFileSize(file.size)}</h4>
                            </div>
                            <div className="flex justify-center items-center relative ml-10">
                                {isOnSubmitLoading && <Spinner className="self-center" />}
                                {/* {isOnSubmitLoading && <LoaderSVG size={50} />} */}
                                {/* <svg width="80" height="80" viewBox="0 0 80 80" className="transform rotate-90"
                                >
                                    <circle
                                        cx="40" cy="40" r={radius} stroke="#e6e6e6" strokeWidth="4" fill="none"
                                    />
                                    <circle
                                        cx="40" cy="40" r={radius} stroke="#4caf50" strokeWidth="4" fill="none"
                                        strokeDasharray={circumference} strokeDashoffset={strokeDashoffset}
                                        style={{
                                            transition: "stroke-dashoffset 0.5s ease",
                                        }}
                                    />
                                </svg> */}

                                {/* <div className="absolute text-center font-semibold text-gray-800">
                                    {Math.round(uploadProgress)}%
                                </div> */}
                            </div>
                            
                        </div>

                    </div>

                    {/* Done Button */}
                    <div className="flex justify-center mt-4 mb-3">
                        <button
                            type="submit" onClick={() => handleFileUpload()}
                            className="flex w-32 justify-center items-center rounded-sm bg-blue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:bg-blue-200"
                            disabled={isAddBtnDisabled || isOnSubmitLoading}
                        >
                            Upload
                        </button>
                    </div>
                </div>
            )
            }
        </div >
    );
}

export default InternalDatabase;
